import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { fetch } from '@nrwl/angular';

import * as TemplateActions from './templates.actions';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { OrderTemplateInterface, OrderTemplateInterfaceWithId } from '@sk/sk-interfaces';
import { OrderTemplateService } from 'services/order-template.service';




@Injectable()
export class TemplatesEffects {

  queryTemplates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TemplateActions.queryFireStoreTemplates),
      switchMap(() => this.templateService.queryStateChangesTemplates()),
      mergeMap(actions => actions),
      map(action => {
        if (action.payload.doc.exists) {
          const payload = {
            ...action.payload.doc.data() as OrderTemplateInterface,
            id: (action.payload.doc.id) ? action.payload.doc.id : null,
            exists: action.payload.doc.exists
          } as OrderTemplateInterfaceWithId;
          // FireStore Events:  'added' | 'removed' | 'modified'
          switch (action.type) {
            case 'added':
              return TemplateActions.fromFireStoreAddTemplate({ template: payload });
              break;
            case 'removed':
              return TemplateActions.fromFireStoreRemoveTemplate({ id: payload.id });
              break;
            case 'modified':
              return TemplateActions.fromFireStoreModifyTemplate({
                template: payload
              });
              break;
          }
        }
      }),
      catchError((error) => {
        return of(TemplateActions.queryFireStoreTemplatesError({
          error
        }));
      })
    )
  );


  updateTemplate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TemplateActions.updateTemplate),
      switchMap(action => {
        return this.templateService.updateTemplateByIdWithNGRX(action.changes, action.id);
      }),
      map(() => TemplateActions.updateTemplateSuccess({})
      ),
      catchError((error) => {
        return of(TemplateActions.updateTemplatesError({
          error
        }));
      })
    )
  );


  addTemplate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TemplateActions.addTemplate),
      switchMap(action => {
        console.log('ADD', action);
        return this.templateService.addTemplateByNgrx(action.template);
      }),
      map(() => TemplateActions.addTemplateSuccess({})),
      catchError((err: Error) => {
        console.error(err);
        if (err) {
          return of(TemplateActions.addTemplateError({ error: err }));
        }
      })
    )
  );

  constructor(private actions$: Actions,
              private templateService: OrderTemplateService) {
  }
}
